<div class="full-height layout-column bringoz-table">

  <div class="tr text-uppercase layout-row layout-align-start-center">

    <!--Service-->
    <div class="th layout-row layout-align-start-center
           large text-ellipsis text-left"
         [ngClass]="isLeanData ? 'flex-40' : 'flex-10'"
    >{{ 'Service' | translate }}
    </div>

    <!--Account-->
    <div *ngIf="!isLeanData" class="th flex-15 layout-row layout-align-start-center large text-ellipsis">
      {{ 'Account' | translate }}
    </div>

    <!--Location-->
    <div *ngIf="!isLeanData" class="th flex-15 layout-row layout-align-start-center large text-ellipsis">
      {{ 'Location' | translate }}
    </div>

    <!--Time Window-->
    <div *ngIf="!isLeanData" class="th flex-15 layout-row layout-align-start-center large text-ellipsis">
      {{ 'Time Window' | translate }}
    </div>

    <!--Agent-->
    <div class="th layout-row layout-align-start-center small text-ellipsis"
         [ngClass]="isLeanData ? 'flex' : 'flex-15'">
      {{ 'Agent' | translate }}
    </div>

    <!--Load-->
    <div *ngIf="!isLeanData" class="th flex layout-row layout-align-start-center small text-ellipsis">
      {{ 'Load' | translate }}
    </div>

    <!--Resource-->
    <div *ngIf="!isLeanData" class="th flex small text-ellipsis">{{ 'DELIVERIES_TABLE_COLUMNS.resource' | translate }}
    </div>

    <!--ETA-->
    <div *ngIf="!isLeanData" class="th flex small text-ellipsis">{{ 'ETA' | translate }}</div>

  </div>

  <div class="full-height flex rows-container layout-column">
    <cdk-virtual-scroll-viewport [itemSize]="60" class="flex viewport" (scroll)="getNextBatch()">
      <div *cdkVirtualFor="let service of services"
           layout="column"
           class="item tr md-no-proxy fade-element-in-only table-row">

        <div class="flex layout-row layout-align-start-center">
          <!--Service-->
          <div class="td layout-row large text-ellipsis"
               [ngClass]="isLeanData ? 'flex-40' : 'flex-10'">
            <div class="flex layout-column">
              <div class="full-width layout-row">
                <app-bringoz-status-tag *ngIf="!service.cancellationReason"
                                        [status]="service.status"
                                        [isSmall]="false"
                                        [extraTooltipText]="service.statusUpdatedAt ? (service.statusUpdatedAt | bringozTimeAgo) : undefined"
                                        class="margin-right-5">

                </app-bringoz-status-tag>


                <app-bringoz-status-tag *ngIf="!!service.cancellationReason"
                                        [status]="service.status"
                                        [isSmall]="false"
                                        [extraTooltipText]="!!service.cancellationReason ? service.cancellationReason.reason + ' - ' + (service.cancellationReason.createdAt | bringozTimeAgo) + ' '+ ('By' | translate) + ' ' + service.cancellationReason.cancelledBy?.name :
                                         (service.statusUpdatedAt | bringozTimeAgo)"
                                        class="margin-right-5">

                </app-bringoz-status-tag>

                <app-service-packed-indication *ngIf="service.serviceType !== 'Operation'"
                                               class="margin-right-5"
                                               [packageList]="service.packages"
                                               [serviceType]="service.serviceType"
                                               [isPacked]="service.autoGeneratedPacked"
                                               [packingInfo]="service.packingInfo"
                                               [packedDate]="service.packedDate">

                </app-service-packed-indication>

                <app-entity-relations-indicator [service]="service"
                                                class="pointer"
                                                (onClick)="onViewServiceRelatedTasks.emit(service)">

                </app-entity-relations-indicator>

              </div>
              <div class="margin-top-5 flex layout-row layout-align-start-center">
                <app-service-link [serviceType]="service.serviceType"
                                  [id]="service.id"
                                  [externalId]="service.externalId"
                                  [ngbTooltip]="service.externalId || service.id"
                                  openDelay="300"
                                  triggers="hover" container="body"
                                  isAllowCopyButton="true">
                </app-service-link>

                <bringoz-icon *ngIf="service.routeReference?.id"
                              class="margin-left-5 secondary-100"
                              [ngbTooltip]="service.routeReference?.id"
                              openDelay="300"
                              triggers="hover"
                              container="body"
                              iconName="route">
                </bringoz-icon>
              </div>
            </div>
          </div>

          <!--Account-->
          <div *ngIf="!isLeanData" class="td flex-15 layout-column large">
            <app-demand-account-link [account]="service.accountReference"
                                     [isAllowCopyButton]="true">
            </app-demand-account-link>
          </div>

          <!--Location-->
          <div *ngIf="!isLeanData" class="td flex-15 large layout-column">
            <div *ngFor="let task of service.taskList"
                 class="layout-row layout-align-start-center text-ellipsis" [ngbTooltip]="locationTooltip"
                 openDelay="300" triggers="hover" container="body">

              <app-task-purpose [purpose]="task.taskSpec?.purpose" class="margin-right-5"
                                firstLetterOnly="true"></app-task-purpose>
              <!--Task Depot-->
              <div *ngIf="task.taskSpec?.locationDetails?.locationType === locationTypes.DEPOT"
                   class="layout-row layout-align-start-center text-ellipsis">
                <bringoz-icon iconName="depot" fill="#A3A3A3" class="margin-right-5"></bringoz-icon>
                <app-depot-link class="text-ellipsis" [isHideTooltip]="true"
                                [depot]="task.taskSpec.depotReference"></app-depot-link>
              </div>

              <!--Task Address-->
              <div *ngIf="task.taskSpec?.locationDetails?.locationType !== locationTypes.DEPOT"
                   class="flex layout-row layout-align-start-center text-ellipsis">
                <span appBringozPpi class="text-ellipsis br-body-1">{{ task.taskSpec.address | bringozAddress }}</span>
              </div>

            </div>

            <ng-template #locationTooltip>
              <div class="layout-column layout-align-start-center">
                <div *ngFor="let task of service.taskList"
                     class="layout-row layout-align-start-center margin-bottom-10">
                  <app-task-purpose [purpose]="task.taskSpec?.purpose" class="margin-right-5"
                                    firstLetterOnly="true"></app-task-purpose>
                  <div class="layout-column layout-align-start-center">
                    <span class="br-body-1">{{ 'Address' | translate }}
                      : {{ task.taskSpec.address | bringozAddress }}</span>
                    <div layout="row" layout-align="start center">
                            <span class="br-body-1 margin-right-10">{{ 'Floor' | translate }}
                              : {{ task.taskSpec.address.floor || '--' }}</span>
                      <span class="br-body-1">{{ 'Apt' | translate }}
                        : {{ task.taskSpec.address.apartment || '--' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>

          <!--Time Window-->
          <div *ngIf="!isLeanData" class="td flex-15 layout-column large">
            <div *ngFor="let task of service.taskList"
                 class="layout-row layout-align-start-center">
              <div class="layout-row layout-align-start-center text-ellipsis">

                <div *ngIf="service.urgency" class="margin-0 margin-right-5 urgency" [ngClass]="service.urgency"
                     [ngbTooltip]="service.urgency | translate" openDelay="300" triggers="hover" container="body"></div>

                <span class="br-body-1 text-ellipsis"
                      [ngbTooltip]="task.taskSpec | timeWindow" openDelay="300"
                      container="body"
                      triggers="hover">{{ task.taskSpec | timeWindow }}</span>
              </div>

              <app-bringoz-time-window-tooltip class="flex-10"
                                               [isTooltip]="true"
                                               [notBefore]="task.taskSpec.notBefore"
                                               [notAfter]="task.taskSpec.notAfter"
                                               [timeZoneId]="task.taskSpec.address.zoneIdName"
                                               [configZoneId]="configZoneId">
              </app-bringoz-time-window-tooltip>

            </div>
          </div>

          <!--Agent-->
          <div class="td layout-column small text-ellipsis agent-column"
               [ngClass]="isLeanData ? 'flex' : 'flex-15'">

            <app-agent-itinerary-link [linkToAgentView]="true"
                                      [agent]="service.agentReference"
                                      [isShowCopyButton]="true">
            </app-agent-itinerary-link>

            <div class="layout-row layout-align-start-center margin-top-5">
              <app-skill-tags *ngIf="service.requiredSkills?.length"
                              [skillsIds]="service.requiredSkills"
                              [limit]="1">

              </app-skill-tags>
              <app-bringoz-tags *ngIf="!!service.agentReference?.tags?.length"
                                class="margin-left-5"
                                [maxTags]="1"
                                [tags]="service.agentReference.tags">
              </app-bringoz-tags>
            </div>
          </div>

          <!--Load-->
          <div *ngIf="!isLeanData"
               class="td flex layout-column small text-ellipsis">
            <div class="layout-row layout-align-start-center">
              <ng-container *ngIf="service.packages?.length && service.packages[0].items">
                <bringoz-icon iconName="weight" fill="#A3A3A3"></bringoz-icon>
                <app-service-package-weight class="text-ellipsis"
                                            *ngIf="service.packages.length && service.packages[0]?.items"
                                            [items]="service.packages[0].items">

                </app-service-package-weight>
              </ng-container>

            </div>
            <div class="layout-row layout-align-start-center">
              <ng-container *ngIf="service.packages?.length && service.packages[0].items">
                <bringoz-icon iconName="volume" fill="#A3A3A3"></bringoz-icon>
                <app-service-package-volume *ngIf="service.packages.length && service.packages[0]?.items"
                                            class="text-ellipsis"
                                            [items]="service.packages[0].items"></app-service-package-volume>
              </ng-container>
            </div>
          </div>

          <!--Resource name-->
          <div *ngIf="!isLeanData" class="td small flex">
            <span *ngIf="!service.routeReference?.id"
                  class="text-ellipsis br-body-1">{{ service.routeReference?.resourceName }}</span>

            <app-bringoz-state-link *ngIf="service.routeReference?.id"
                                    [state]="'planning-route'"
                                    [params]="{id: service.routeReference.id}"
                                    [permission]="'routes.list'"
                                    [text]="service.routeReference.resourceName || service.routeReference.id"
                                    [ngbTooltip]="service.routeReference.resourceName || service.routeReference.id"
                                    openDelay="300"
                                    container="body"
                                    triggers="hover">
            </app-bringoz-state-link>
          </div>

          <!--ETAs-->
          <div *ngIf="!isLeanData" class="td flex layout-column small text-ellipsis">
            <div *ngIf="service.status ==='Completed'" class="layout-column layout-align-center-start">
                          <span class="br-body-1 text-ellipsis" [ngbTooltip]="statusUpdatedAtTooltip" openDelay="300"
                                container="body"
                                triggers="hover">{{ 'Completed' | translate }}:</span>
              <div layout="row" class="layout-row layout-align-start-center">
                <span class="br-body-1">{{ service | bringozTime: 'statusUpdatedAt' }}</span>

                <app-bringoz-eta-tooltip [eta]="service.statusUpdatedAt"
                                         [timeZoneId]="service.taskList[0].taskSpec.address.zoneIdName"
                                         [configZoneId]="configZoneId"></app-bringoz-eta-tooltip>
              </div>
              <ng-template #statusUpdatedAtTooltip>
                <div>
                  <span class="br-body-1">{{ 'Completed' | translate }}:</span>
                  <span class="br-body-1">{{ service | bringozTime: 'statusUpdatedAt' }}</span>
                </div>
              </ng-template>
            </div>

            <ng-container *ngIf="service.status !== 'Completed'">
              <app-task-eta *ngFor="let task of service.taskList"
                            [task]="task"
                            [configZoneId]="configZoneId"
                            [timeZoneId]="task.taskSpec.address.zoneIdName">

              </app-task-eta>
            </ng-container>


          </div>

        </div>

      </div>
    </cdk-virtual-scroll-viewport>
  </div>

</div>
